var SECURITY_DISCLAIMER_REMINDER = 'Por su seguridad, por favor no ingrese información personal (por ejemplo, número de seguridad social, número de tarjeta de crédito y/o información médica protegida).';
var cancelDispute = {
    modalHeader: '¿Está seguro de que desea cancelar esta disputa?',
    modalDescription: 'Si cancela, su disputa se cerrará y no investigaremos más la disputa.',
    modalSubtitle: 'Seleccione un motivo para cancelar su disputa:',
    reason1: 'Trabajé con el Comerciante para resolverla.',
    reason2: 'Recibí mi mercancía.',
    reason3: 'Recibí mi crédito.',
    reason4: 'Acepto el cargo disputado.',
    reason5: 'Otro',
    otherReason: 'Describa brevemente el motivo:',
    confirmationHeader: 'Su solicitud de cancelación ha sido recibida y está siendo procesada.',
    confirmationDescription: 'Le notificaremos con una carta una vez que el reclamo haya sido cerrado. Por favor espere 7 dias hábiles para que completa tu solicitud.',
    errorHeader: 'Lo sentimos.',
    errorDescription: 'En este momento no podemos cancelar su disputa. Por favor, intente nuevamente más tarde.',
    title: 'Cancelar Disputa',
    securityDisclaimerReminderTitle: 'Recordatorio:',
    securityDisclaimerReminder: SECURITY_DISCLAIMER_REMINDER,
    securityDisclaimerNoteTitle: 'Importante:',
    securityDisclaimerHelpNote: 'Usted tendrá la oportunidad de cargar documentos de respaldo que le gustaría compartir después de enviar esta disputa.',
    securityDisclaimerHelpText: 'Por su seguridad, no ingrese información personal.'
};
export default cancelDispute;
//# sourceMappingURL=cancelDispute.js.map